/// <reference path="employee.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Controls {
    class ApplyTemplateController {

        static $inject = ["$filter", "$mdDialog", "context", "isClear"]
        public context: any;
        public selectedTemplate: any;

        public mainTab: boolean;
        public compensationsTab: boolean;
        public deductionTab: boolean;
        public categories = { enabled: false, updateType: 0 };
        public servicesTab = { enabled: false, updateType: 0 };
        public locationsTab = { enabled: false, updateType: 1 };
        public commissionsOverrideTab = { enabled: false, updateType: 0 };
        public all: boolean;
        private appliedTemplate: Model.AppliedTemplate;

        constructor(protected $filter: angular.IFilterService,
            private $mdDialog: angular.material.IDialogService,
            context: any,
            private isClear: boolean) {
            this.context = context;
            this.toggleAll = true;
        }

        apply = () => {
            // only valid apply or clear
            if (!this.isClear && !(this.selectedTemplate && (this.mainTab || this.compensationsTab || this.deductionTab || this.commissionsOverrideTab.enabled || this.categories.enabled || this.servicesTab.enabled || this.locationsTab.enabled))) {
                return;
              }
            // initialize applied template
            this.appliedTemplate = {};
            this.appliedTemplate.sections = new Array();
            // collect apply sections
            if (this.all || this.mainTab) {
              this.appliedTemplate.sections.push({ sectionType: Model.AppliedTemplateSectionTypeEnum.Main, updateType: Model.AppliedTemplateSectionUpdateTypeEnum.Replace });
            }
            if (this.all || this.compensationsTab) {
                this.appliedTemplate.sections.push({ sectionType: Model.AppliedTemplateSectionTypeEnum.Compensations, updateType: Model.AppliedTemplateSectionUpdateTypeEnum.Replace });
            }
            if (this.all || this.deductionTab) {
                this.appliedTemplate.sections.push({ sectionType: Model.AppliedTemplateSectionTypeEnum.Deduction, updateType: Model.AppliedTemplateSectionUpdateTypeEnum.Replace });
            }
            if (this.all || this.commissionsOverrideTab.enabled) {
                this.appliedTemplate.sections.push({ sectionType: Model.AppliedTemplateSectionTypeEnum.CommissionsOverrides, updateType: this.commissionsOverrideTab.updateType });
            }
            if (this.all || this.categories.enabled) {
              this.appliedTemplate.sections.push({ sectionType: Model.AppliedTemplateSectionTypeEnum.Categories, updateType: this.categories.updateType });
            }
            if (this.all || this.servicesTab.enabled) {
              this.appliedTemplate.sections.push({ sectionType: Model.AppliedTemplateSectionTypeEnum.Services, updateType: this.servicesTab.updateType });
            }
            if (this.all || this.locationsTab.enabled) {
              this.appliedTemplate.sections.push({ sectionType: Model.AppliedTemplateSectionTypeEnum.Locations, updateType: this.locationsTab.updateType });
            }

            if (!this.isClear) {
              // prepare to apply
              this.appliedTemplate.templateId = this.selectedTemplate.id;
              this.context.applyTemplate(this.appliedTemplate);
            }
            else {
              // clear
              this.context.clearTemplate();
            }
            this.$mdDialog.hide();
        }
        cancel = () => {
            this.$mdDialog.hide();
        }

        get toggleAll(): boolean {
            return this.all;
        }
        set toggleAll(value: boolean) {
            this.mainTab = this.compensationsTab = this.deductionTab = this.commissionsOverrideTab.enabled = this.servicesTab.enabled = this.locationsTab.enabled = this.categories.enabled = this.all = value;
        }
        
    }

    angular.module("meevo.plugins.employee")
    .controller("meevo.plugins.employee.ApplyTemplateController", ApplyTemplateController);
}